<template>
  <v-container v-if="user" fluid style="background-color: #f9f9f9">
    <!-- Barra superior -->
    <v-row class="mb-2" align="center" justify="space-between">
      <v-col cols="12" md="auto" class="d-flex align-center">
        <v-btn
          class="mr-4"
          color="white"
          :class="
            selectedOption === 'pedidos' ? 'enabled-button' : 'disabled-button'
          "
          @click="selectedOption = 'pedidos'"
          >Pedidos</v-btn
        >

        <v-btn
          v-if="permisoAreaTrabajo"
          :class="
            selectedOption === 'areaTrabajo'
              ? 'enabled-button'
              : 'disabled-button'
          "
          color="white"
          @click="selectedOption = 'areaTrabajo'"
        >
          Área de trabajo
        </v-btn>
        <v-btn
          class="ml-4"
          color="white"
          :class="
            selectedOption === 'preciosExistencias'
              ? 'enabled-button'
              : 'disabled-button'
          "
          @click="selectedOption = 'preciosExistencias'"
        >
          Precios y Existencias
        </v-btn>
        <v-btn
          class="ml-4"
          color="white"
          :class="
            selectedOption === 'faltantesVendedores'
              ? 'enabled-button'
              : 'disabled-button'
          "
          @click="selectedOption = 'faltantesVendedores'"
        >
          Faltantes
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" ref="detallePedido">
        <div v-if="selectedOption === 'pedidos'">
          <!-- Filtros de estado -->
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="busqueda"
                label="Buscar pedido..."
                hide-details
                solo
                dense
                prepend-inner-icon="mdi-magnify"
                class="mr-4"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" class="d-flex flex-wrap">
              <v-btn
                v-for="estado in estados"
                :key="estado.value"
                class="mr-2 mb-2 bordered-button"
                :class="
                  estadoSeleccionado === estado.value
                    ? 'white--text'
                    : 'black--text'
                "
                :color="
                  estadoSeleccionado === estado.value ? '#6A8FB3' : 'white'
                "
                @click="scrollToEstado(estado.value)"
              >
                {{ estado.text }}
              </v-btn>
              <v-btn color="#6A8FB3" icon @click="verComentarios = true"
                ><v-icon>{{
                  hayComentariosNoLeidos
                    ? "mdi-bell-badge"
                    : "mdi-bell-check-outline"
                }}</v-icon></v-btn
              >
            </v-col>
          </v-row>

          <!-- 📱 Vista vertical (portrait): pedidos + detalle expandible -->
          <v-col cols="12" v-if="isPortrait">
            <div v-for="estado in estados" :key="estado.value">
              <h2 class="mb-2">
                {{ estado.text
                }}<v-avatar class="ml-4" color="#6A8FB3" size="32">
                  <span class="white--text font-weight-bold text-body-2">{{
                    cantidadPedidosPorEstado(estado.value)
                  }}</span>
                </v-avatar>
              </h2>
              <v-card
                :id="'pedido-' + pedido.id"
                v-for="pedido in pedidos.filter(
                  (p) =>
                    p.estado === estado.value &&
                    (getNombreCliente(p.cliente)
                      .toLowerCase()
                      .includes(busqueda.toLowerCase()) ||
                      p.id.toString().includes(busqueda) ||
                      getAntiguedad(p.fecha_creacion).includes(busqueda)),
                )"
                :key="pedido.id"
                class="mb-2"
                outlined
                elevation="4"
              >
                <!-- Cabecera clickeable -->
                <v-card-text
                  class="d-flex justify-space-between align-center"
                  @click="
                    pedido.expanded = !pedido.expanded;
                    seleccionarPedido(pedido);
                  "
                >
                  <div>
                    <div class="d-flex justify-space-between">
                      <h3 class="m-auto">Pedido #{{ pedido.id }}</h3>
                      <v-chip
                        :color="getColorPorEstado(pedido.estado)"
                        v-if="pedido.estado === estado.value"
                        text-color="black"
                        class="mb-2"
                        >Pedido
                        {{
                          estado.text === "Creados"
                            ? "Creado"
                            : estado.text || estado.text !== "Creados"
                            ? "en " + estado.text
                            : estado.text || estado.text === "En ruta"
                            ? "" + estado.text
                            : estado.text
                        }}</v-chip
                      >
                    </div>

                    <div class="subtitle-1 grey--text text--darken-1 mt-2">
                      {{ getNombreCliente(pedido.cliente) }}
                    </div>
                    <h4 class="grey--text mt-2 background-circle">
                      {{
                        pedido.expanded
                          ? "Ocultar detalles..."
                          : "Ver detalles..."
                      }}
                    </h4>
                  </div>
                  <div class="text-right">
                    <v-chip
                      class="mb-5"
                      :color="
                        getDias(pedido.fecha_creacion) > 25
                          ? 'red lighten-4'
                          : getDias(pedido.fecha_creacion) > 15
                          ? 'orange lighten-4'
                          : 'green lighten-4'
                      "
                      variant="elevated"
                      :class="colorDias(getDias(pedido.fecha_creacion))"
                    >
                      {{ getAntiguedad(pedido.fecha_creacion) }}
                    </v-chip>
                    <h3 class="mt-4">{{ formatoMoneda(pedido.total) }}</h3>
                  </div>
                </v-card-text>

                <!-- Contenido expandible -->
                <v-expand-transition>
                  <div v-show="pedido.expanded">
                    <v-divider></v-divider>
                    <v-card-text>
                      <v-col class="d-flex justify-space-between">
                        <v-btn
                          small
                          rounded
                          class="btn-historial white--text"
                          color="#6A8FB3"
                          @click="verHistorial = true"
                          >Ver Historial</v-btn
                        >
                        <v-btn
                          icon
                          color="#BA4E38"
                          @click="cancelarPedido = true"
                        >
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </v-col>
                      <p>
                        <strong>Pago:</strong>
                        {{ pedido.contado === true ? "Contado" : "Crédito" }}
                      </p>

                      <div v-if="pedido.discrepancias">
                        <p class="font-weight-bold">Discrepancias:</p>
                        <p>{{ pedido.discrepancias }}</p>
                      </div>

                      <div>
                        <p class="font-weight-bold">Productos:</p>
                        <ul>
                          <li
                            v-for="producto in pedido.productos.lista_productos"
                            :key="producto.codigo"
                          >
                            {{ producto.codigo }} - {{ producto.nombre }} ({{
                              producto.cantidad
                            }})
                          </li>
                        </ul>
                      </div>

                      <!-- Swipe para confirmar -->
                      <div
                        v-if="
                          pedido.estado === 'pedido_creado' &&
                          getSiguienteEstado(pedido)?.value === 'confirmacion'
                        "
                        class="swipe-container mt-4"
                      >
                        <div class="swipe-track" :ref="'track-' + pedido.id">
                          <div
                            class="swipe-fill"
                            :style="{ width: thumbPosition + 'px' }"
                          ></div>
                          <div
                            class="swipe-thumb"
                            :class="{ dragging2: dragging2 }"
                            :style="{ left: thumbPosition + 'px' }"
                            @pointerdown.prevent.stop="
                              startDrag2(pedido.id, $event)
                            "
                          >
                            <v-icon color="white">mdi-arrow-right</v-icon>
                          </div>
                          <span class="swipe-text">
                            Desliza para avanzar a:
                            {{ getSiguienteEstado(pedido).text }}</span
                          >
                        </div>
                      </div>
                    </v-card-text>
                  </div>
                </v-expand-transition>
              </v-card>
              <div
                v-if="!pedidos.some((p) => p.estado === estado.value)"
                class="grey--text mb-4"
              >
                No hay pedidos en {{ estado.text }}.
              </div>
            </div>
          </v-col>

          <!-- 💻 Vista horizontal (landscape): pedidos + detalle lado a lado -->
          <v-row v-if="!isPortrait">
            <!-- Lista de pedidos -->
            <v-col cols="12" md="5">
              <div v-for="estado in estados" :key="estado.value" class="mb-6">
                <h2 class="mb-2">
                  {{ estado.text
                  }}<v-avatar class="ml-4" color="#6A8FB3" size="32">
                    <span class="white--text font-weight-bold text-body-2">{{
                      cantidadPedidosPorEstado(estado.value)
                    }}</span>
                  </v-avatar>
                </h2>
                <div>
                  <v-card
                    v-for="pedido in pedidos.filter(
                      (p) =>
                        p.estado === estado.value &&
                        (getNombreCliente(p.cliente)
                          .toLowerCase()
                          .includes(busqueda.toLowerCase()) ||
                          p.id.toString().includes(busqueda) ||
                          getAntiguedad(p.fecha_creacion).includes(busqueda)),
                    )"
                    :key="pedido.id"
                    class="mb-4"
                    outlined
                    hover
                    elevation="6"
                    @click="seleccionarPedido(pedido)"
                  >
                    <v-card-text
                      class="d-flex justify-space-between align-center"
                    >
                      <div>
                        <h3 class="">Pedido #{{ pedido.id }}</h3>

                        <div class="subtitle-1 grey--text text--darken-1 mt-2">
                          {{ getNombreCliente(pedido.cliente) }}
                        </div>
                        <div class="grey--text mt-2">Ver detalles...</div>
                      </div>
                      <div class="text-right">
                        <v-chip
                          :color="
                            getDias(pedido.fecha_creacion) > 25
                              ? 'red lighten-4'
                              : getDias(pedido.fecha_creacion) > 15
                              ? 'orange lighten-4'
                              : 'green lighten-4'
                          "
                          variant="elevated"
                          :class="colorDias(getDias(pedido.fecha_creacion))"
                        >
                          {{ getAntiguedad(pedido.fecha_creacion) }}
                        </v-chip>
                        <h3 class="mt-2">
                          {{ formatoMoneda(pedido.total) }}
                        </h3>
                      </div>
                    </v-card-text>
                  </v-card>
                </div>
                <div
                  v-if="!pedidos.some((p) => p.estado === estado.value)"
                  class="grey--text mb-4"
                >
                  No hay pedidos en {{ estado.text }}
                </div>
              </div>
            </v-col>

            <!-- Detalle del pedido -->
            <v-col cols="12" md="7" style="position: relative">
              <v-card
                v-if="pedidoSeleccionado"
                outlined
                class="pa-4"
                style="position: sticky; top: 100px"
                elevation="6"
              >
                <div class="d-flex justify-space-between">
                  <h2>Pedido #{{ pedidoSeleccionado.id }}</h2>
                  <v-spacer></v-spacer>
                  <div v-for="estado in estados" :key="estado.value">
                    <v-chip
                      :color="getColorPorEstado(pedidoSeleccionado.estado)"
                      v-if="pedidoSeleccionado.estado === estado.value"
                      text-color="black"
                      >Pedido
                      {{
                        estado.text === "Creados"
                          ? "Creado"
                          : estado.text || estado.text !== "Creados"
                          ? "en " + estado.text
                          : estado.text || estado.text === "En ruta"
                          ? "" + estado.text
                          : estado.text
                      }}</v-chip
                    >
                  </div>
                  <v-spacer></v-spacer>
                  <v-btn icon color="#BA4E38" @click="cancelarPedido = true">
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </div>

                <p class="subtitle-1">
                  {{ getNombreCliente(pedidoSeleccionado.cliente) }}
                </p>
                <v-btn
                  small
                  rounded
                  class="btn-historial white--text"
                  color="#6A8FB3"
                  @click="verHistorial = true"
                  >Ver Historial</v-btn
                >
                <p class="mt-2">
                  <strong>Pago:</strong>
                  {{
                    pedidoSeleccionado.contado === true ? "Contado" : "Credito"
                  }}
                </p>

                <div v-if="pedidoSeleccionado.discrepancias">
                  <p class="font-weight-bold">Discrepancias:</p>
                  <p>{{ pedidoSeleccionado.discrepancias }}</p>
                </div>

                <div>
                  <p class="font-weight-bold">Productos:</p>
                  <ul>
                    <li
                      v-for="producto in pedidoSeleccionado.productos
                        .lista_productos"
                      :key="producto.codigo"
                    >
                      {{ producto.codigo }} - {{ producto.nombre }} ({{
                        producto.cantidad
                      }})
                    </li>
                  </ul>
                </div>
                <div
                  v-if="
                    pedidoSeleccionado &&
                    pedidoSeleccionado.estado === 'pedido_creado' &&
                    getSiguienteEstado(pedidoSeleccionado)?.value ===
                      'confirmacion'
                  "
                  class="swipe-container mt-4"
                >
                  <div class="swipe-track" ref="track">
                    <div
                      class="swipe-fill"
                      :style="{ width: thumbPosition + 'px' }"
                    ></div>
                    <div
                      class="swipe-thumb"
                      :class="{ dragging: dragging }"
                      :style="{ left: thumbPosition + 'px' }"
                      @mousedown="startDrag"
                      @touchstart="startDrag"
                    >
                      <v-icon color="white">mdi-arrow-right</v-icon>
                    </div>
                    <span class="swipe-text">
                      Desliza para avanzar a:
                      {{ getSiguienteEstado(pedidoSeleccionado).text }}
                    </span>
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </div>
        <div v-if="selectedOption === 'areaTrabajo'">
          <AreaTrabajo
            :productos="productos"
            :usuarios="usuarios"
            :clientes="clientes"
          />
        </div>
        <div v-if="selectedOption === 'preciosExistencias'">
          <PreciosExistenciasView
            :productos="productos"
            :usuarios="usuarios"
            :clientes="clientes"
          />
        </div>
        <div v-if="selectedOption === 'faltantesVendedores'">
          <FaltantesVendedores
            :productos="productos"
            :usuarios="usuarios"
            :clientes="clientes"
            tipoArea="faltantesVendedores"
          />
        </div>
      </v-col>
    </v-row>
    <v-dialog
      v-model="verComentarios"
      max-width="600"
      scrollable
      transition="dialog-top-transition"
    >
      <v-card :color="'dialog-comentarios'">
        <v-card-title class="headline">
          Comentarios de los pedidos.
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <div
            v-for="comentario in comentariosPedidosOrdenados"
            :key="comentario.id"
            class="mb-2"
            @click="abrirHistorialDesdeComentarios(comentario)"
          >
            <div class="d-flex align-center">
              <strong>Pedido #{{ comentario.id_objeto }}</strong>
              <v-btn
                icon
                small
                class="ml-2"
                @click.stop="marcarLeido(comentario)"
              >
                <v-icon color="primary">
                  {{
                    comentario.leido
                      ? "mdi-eye-check-outline"
                      : "mdi-eye-outline"
                  }}
                </v-icon>
              </v-btn>
              <v-icon
                v-if="comentario.leido"
                color="blue lighten-2"
                small
                class="ml-1"
                >mdi-check-all</v-icon
              >
            </div>
            <p class="">Comentario: {{ comentario.texto_comentario }}</p>
            <small class=""
              >Por: {{ getNombreUsuario(comentario.usuario) }}</small
            ><br />
            <small class="">{{
              formatearFechaComentario(comentario.fecha_creacion)
            }}</small>
            <v-divider class="border-opacity-75"></v-divider>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="" text @click="verComentarios = false"> Cerrar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbar"
      :timeout="3000"
      top
      center
      color="#6A8FB3"
      vertical
    >
      Nuevo comentario para el pedido
      <template v-if="comentarioNotificado">
        #{{ comentarioNotificado.id_objeto }}
        <br />
        <small
          >Hecho por:
          {{ getNombreUsuario(comentarioNotificado.usuario) }}</small
        >
      </template>
      <template v-else>
        <!-- muestra un mensaje alternatico en caso de error del if -->
        <span>Nuevo comentario recibido</span>
      </template>
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="verComentarios = true">
          Ver
        </v-btn>
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
          Cerrar
        </v-btn>
      </template>
    </v-snackbar>

    <v-dialog v-model="cancelarPedido" max-width="500">
      <v-card v-if="pedidoSeleccionado">
        <v-card-title class="">
          ¿Deseas cancelar el pedido #{{ pedidoSeleccionado.id }}?
        </v-card-title>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn class="white--text" color="#6A8FB3" @click="CancelarPedido">
            Si, cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            class="white--text"
            color="#6A8FB3"
            @click="cancelarPedido = false"
          >
            No
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="verHistorial" max-width="800">
      <verPedidoVendedor
        v-if="pedidoSeleccionado"
        :item="pedidoSeleccionado"
        :usuarios="usuarios"
        :comentarios="comentariosPedidos"
        @cerrarDialog="verHistorial = false"
      />
    </v-dialog>
  </v-container>
</template>

<script>
import axios from "axios";
import AreaTrabajo from "@/components/AreaTrabajo.vue";
import { mapGetters } from "vuex";
import PreciosExistenciasView from "@/views/PreciosExistenciasView.vue";
import FaltantesVendedores from "@/views/FaltantesVendedores.vue";
import verPedidoVendedor from "@/components/verPedidoVendedor.vue";
import { format, subMinutes } from "date-fns";

export default {
  data() {
    return {
      busqueda: "",
      estadoSeleccionado: "",
      pedidos: [],
      clientes: [],
      pedidoSeleccionado: null,
      estados: [
        {
          text: "Creados",
          value: "pedido_creado",
        },
        {
          text: "Revisión de crédito",
          value: "revision_de_credito",
        },
        {
          text: "Confirmacion",
          value: "confirmacion",
        },
        {
          text: "Facturación",
          value: "facturacion",
        },
        {
          text: "Preparación",
          value: "preparacion_en_almacen",
        },
        {
          text: "Preparado",
          value: "preparado",
        },
        {
          text: "En ruta",
          value: "en_ruta_de_entrega",
        },
      ],
      ordenEstados: [
        {
          text: "Pedido creado",
          value: "pedido_creado",
        },
        {
          text: "Confirmación",
          value: "confirmacion",
        },
        {
          text: "Facturación",
          value: "facturacion",
        },
        {
          text: "Preparación en almacén",
          value: "preparacion_en_almacen",
        },
        {
          text: "Preparado",
          value: "preparado",
        },
        {
          text: "En ruta de entrega",
          value: "en_ruta_de_entrega",
        },
        {
          text: "Entregado",
          value: "entregado",
        },
      ],
      dragging: false,
      dragging2: false,
      startX: 0,
      thumbPosition: 0,
      trackWidth: 0,
      // Variables para debouncing simple
      lastDragTime: 0,
      dragThrottleMs: 8, // ~120fps max para mayor fluidez

      selectedOption: "pedidos",
      productos: [],
      usuarios: [],
      permisoAreaTrabajo: false,
      isPortrait: window.innerHeight > window.innerWidth,
      draggingPedidoId: null,
      snackbar: false,
      verComentarios: false,
      comentariosPedidos: [],
      ComentariosNuevos: [],
      comentarioNotificado: null,
      verHistorial: false,
      cancelarPedido: false,
    };
  },
  methods: {
    async CancelarPedido() {
      try {
        const response = await axios.post(
          `/pedidos/avanzar_pedido?id_pedido=${this.pedidoSeleccionado.id}&nuevo_estado=cancelado`,
        );
        console.log(response.data);
        this.cancelarPedido = false;
        alert("Pedido Cancelado correctamente.");
      } catch (error) {
        console.error(error);
        alert(error.response.data.detail);
      }
    },

    abrirHistorialDesdeComentarios(comentario) {
      const pedido = this.pedidos.find((p) => p.id === comentario.id_objeto);
      if (pedido) {
        this.pedidoSeleccionado = pedido;
        this.verHistorial = true;
        this.verComentarios = false;
      } else {
        alert("No se encontro el pedido de este comentario");
      }
    },

    async getComentariosPedidos() {
      const comentarios = [];
      for (const pedido of this.pedidos) {
        try {
          const response = await axios.get(
            `/varios/get_comentarios?id_objeto=${pedido.id}&tipo_objeto=pedido`,
          );
          if (Array.isArray(response.data)) {
            comentarios.push(...response.data);
          } else if (response.data) {
            comentarios.push(response.data);
          }
        } catch (error) {
          console.error(
            "Error al obtener los comentarios del pedido " + pedido.id,
            error,
          );
        }
      }
      comentarios.sort((a, b) => {
        return new Date(b.fecha_creacion) - new Date(a.fecha_creacion);
      });
      //agregar el campo de leido si no existe
      comentarios.forEach((comentario) => {
        if (typeof comentario.leido === "undefined") comentario.leido = false;
      });
      //guardar en localstorage los comentarios leidos
      const leidos =
        JSON.parse(localStorage.getItem("comentariosLeidos")) || [];
      comentarios.forEach((comentario) => {
        comentario.leido = leidos.includes(comentario.id);
      });

      this.comentariosPedidos = comentarios;
      //console.log("comentariosPedidos:", this.comentariosPedidos);
    },

    async getComentariosNuevos() {
      const currentDate = new Date();
      let fechaComentarios = "";
      //cada 1 minuto
      fechaComentarios = format(
        subMinutes(currentDate, 15),
        "yyyy-MM-dd HH:mm:ssXX",
      );
      try {
        const response = await axios.get(
          `/varios/get_comentarios_nuevos?tipo_objeto=pedido&fecha=${fechaComentarios}`,
        );
        this.ComentariosNuevos = response.data;
        //console.log("ComentariosNuevos:", this.ComentariosNuevos);
        if (this.ComentariosNuevos.length > 0) {
          // Obtén el comentario más reciente del pedido notificado
          const idPedido = this.ComentariosNuevos[0];
          const responseComentario = await axios.get(
            `/varios/get_comentarios?id_objeto=${idPedido}&tipo_objeto=pedido`,
          );
          // Si la respuesta es un array, toma el más reciente (el primero si ya está ordenado)
          let comentarioMasReciente = Array.isArray(responseComentario.data)
            ? responseComentario.data[0]
            : responseComentario.data;
          //agregar el campo leido si no existe
          if (typeof comentarioMasReciente.leido === "undefined")
            comentarioMasReciente.leido = false;

          //guardar en localstorage los comentarios leidos
          const leidos =
            JSON.parse(localStorage.getItem("comentariosLeidos")) || [];
          comentarioMasReciente.leido = leidos.includes(
            comentarioMasReciente.id,
          );

          let notificados = JSON.parse(
            localStorage.getItem("comentariosNotificados") || "[]",
          );
          if (!notificados.includes(comentarioMasReciente.id)) {
            this.comentarioNotificado = comentarioMasReciente;
            this.snackbar = true;
            notificados.push(comentarioMasReciente.id);
            localStorage.setItem(
              "comentariosNotificados",
              JSON.stringify(notificados),
            );
          }

          //console.log("Comentario notificado:", this.comentarioNotificado);
        }
      } catch (error) {
        console.error(error);
      }
    },

    async getPermisoAgregarPrepedido() {
      try {
        const response = await axios.get(`/usuarios/yo`);
        // Separar el string en partes usando espacio como delimitador
        const permisos = response.data.permisos.split(" ");

        // Definir los sufijos buscados
        const sufijosBuscados = [
          ":pedidos:crear",
          "pedidos:crear_ageno",
          ":ADMINISTRADOR",
        ];

        // Comprobar si alguna parte termina con alguno de los sufijos buscados
        const algunaParteTerminaConSufijo = permisos.some((parte) =>
          sufijosBuscados.some((sufijo) => parte.endsWith(sufijo)),
        );

        // algunaParteTerminaConSufijo será true si alguna parte termina con "_existencia", de lo contrario, será false
        // console.log(algunaParteTerminaConSufijo);
        this.permisoAreaTrabajo = algunaParteTerminaConSufijo;
      } catch (error) {
        console.error(error);
      }
    },

    async getProductos() {
      try {
        const response = await axios.get(`/productos/get_lista`);
        this.productos = response.data;
      } catch (error) {
        console.error(error);
      }
    },

    async getUsuarios() {
      try {
        const response = await axios.get(`/usuarios/get_usuarios`);
        this.usuarios = response.data.usuarios;
      } catch (error) {
        console.error(error);
      }
    },

    getNombreUsuario(usuarioId) {
      const usuarioEncontrado = this.usuarios.find(
        (usuario) => usuario.id === usuarioId,
      );
      if (usuarioEncontrado) {
        return usuarioEncontrado.nombre;
      }
      return "";
    },

    async getPedidos() {
      try {
        const response = await axios.get(`/pedidos/get_abiertos`);
        const data = response.data;

        this.pedidos = data.reduce((acc, sucursal) => {
          const pedidosConSucursal = sucursal.pedidos.map((p) => ({
            ...p,
            sucursal: sucursal.sucursal,
            expanded: false,
          }));
          return acc.concat(pedidosConSucursal);
        }, []); // Inicializar el acumulador con un array vacío
        //console.log(this.pedidos);
        await this.getComentariosPedidos();
      } catch (error) {
        console.error(error);
      }
    },

    async getClientes() {
      try {
        const response = await axios.get(`/clientes/get_nombres`);
        this.clientes = response.data;
      } catch (error) {
        console.error(error);
      }
    },

    getNombreCliente(clienteId) {
      const clienteEncontrado = this.clientes.find(
        (cliente) => cliente.id === clienteId,
      );
      if (clienteEncontrado) {
        return clienteEncontrado.razon_social + " ";
      }
      return "";
    },
    seleccionarPedido(pedido) {
      this.pedidoSeleccionado = pedido;

      if (!this.isPortrait) {
        this.$nextTick(() => {
          if (this.$refs.track) {
            this.trackWidth = this.$refs.track.offsetWidth;
          }
        });
      } else {
        this.$nextTick(() => {
          setTimeout(() => {
            const el = document.getElementById(`pedido-${pedido.id}`);
            if (el) {
              el.scrollIntoView({
                behavior: "smooth",
                block: "start",
              });
            }

            if (this.$refs.track) {
              this.trackWidth = this.$refs.track.offsetWidth;
            }
          }, 400);
        });
      }
    },

    formatoMoneda(valor) {
      return new Intl.NumberFormat("es-MX", {
        style: "currency",
        currency: "MXN",
      }).format(valor);
    },
    getDias(fecha_creacion) {
      const now = new Date();
      const fecha = new Date(fecha_creacion);
      const diffMs = now - fecha;
      return Math.floor(diffMs / (1000 * 60 * 60 * 24));
    },
    getAntiguedad(fecha_creacion) {
      const now = new Date();
      const fecha = new Date(fecha_creacion);
      const diffMs = now - fecha;
      const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
      const diffHrs = Math.floor(
        (diffMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
      );
      const diffMins = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

      if (diffDays > 0) {
        return `${diffDays} día${diffDays > 1 ? "s" : ""}`;
      } else if (diffHrs > 0) {
        return `${diffHrs} hora${diffHrs > 1 ? "s" : ""}`;
      } else if (diffMins > 0) {
        return `${diffMins} minuto${diffMins > 1 ? "s" : ""}`;
      } else {
        return `menos de un minuto`;
      }
    },
    formatearFechaComentario(fecha) {
      if (!fecha) return "";
      const opciones = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      };
      return new Date(fecha).toLocaleDateString("es-MX", opciones);
    },
    colorDias(dias) {
      if (dias > 25) return "red--text";
      if (dias > 15) return "orange--text";
      return "green--text";
    },

    startDrag(e) {
      if (this.dragging) return;
      e.preventDefault();

      this.dragging = true;
      this.startX = e.touches ? e.touches[0].clientX : e.clientX;
      this.thumbPosition = 0; // Reset position
      this.lastDragTime = 0;

      if (this.$refs.track) {
        this.trackWidth = this.$refs.track.offsetWidth;
        // Agregar clase dragging para desactivar transiciones
        this.$refs.track.classList.add("dragging");
      }

      if (this.$refs.thumb) {
        this.$refs.thumb.classList.add("dragging");
        // Reset transform
        this.$refs.thumb.style.transform = "translateX(0px)";
      }

      // Usar listeners pasivos para mejor rendimiento
      window.addEventListener("mousemove", this.onDrag, { passive: true });
      window.addEventListener("mouseup", this.stopDrag, { passive: true });
      window.addEventListener("touchmove", this.onDrag, { passive: true });
      window.addEventListener("touchend", this.stopDrag, { passive: true });
    },

    startDrag2(pedidoId, event) {
      if (this.dragging2) return;
      // obtener clientX
      const clientX = event.touches ? event.touches[0].clientX : event.clientX;

      // obtener el elemento track correcto por pedido
      let trackEl = this.$refs["track-" + pedidoId];
      if (Array.isArray(trackEl)) trackEl = trackEl[0];
      this.trackWidth = trackEl ? trackEl.offsetWidth : 0;

      this.startX = clientX;
      this.dragging2 = true;
      this.draggingPedidoId = pedidoId;
      // reset thumbPosition for this drag
      this.thumbPosition = 0;

      // try to capture pointer to ensure pointer events are routed to this element
      try {
        if (event.pointerId && event.target && event.target.setPointerCapture) {
          event.target.setPointerCapture(event.pointerId);
        }
      } catch (e) {
        // ignore if not supported
      }

      // listeners mientras arrastra (pointer unifica touch+mouse)
      window.addEventListener("pointermove", this.onDrag2, { passive: false });
      window.addEventListener("pointerup", this.stopDrag2);
      // evitar selección de texto mientras arrastra
      document.body.style.userSelect = "none";
    },

    onDrag(e) {
      if (!this.dragging) return;

      // Debouncing simple basado en tiempo
      const now = performance.now();
      if (now - this.lastDragTime < this.dragThrottleMs) return;
      this.lastDragTime = now;

      const clientX = e.touches ? e.touches[0].clientX : e.clientX;
      const delta = clientX - this.startX;

      this.startX = clientX;

      // Usar transform directo para mejor rendimiento
      const newPosition = Math.max(
        0,
        Math.min(this.thumbPosition + delta, this.trackWidth - 50),
      );

      this.thumbPosition = newPosition;

      // Aplicar transform directamente al elemento
      if (this.$refs.thumb) {
        this.$refs.thumb.style.transform = `translateX(${newPosition}px)`;
      }
    },

    onDrag2(e) {
      if (!this.dragging2) return;

      // Debouncing simple basado en tiempo
      const now = performance.now();
      if (now - this.lastDragTime < this.dragThrottleMs) return;
      this.lastDragTime = now;

      const clientX = e.touches ? e.touches[0].clientX : e.clientX;
      const delta = clientX - this.startX;
      this.startX = clientX;

      // Usar transform directo para mejor rendimiento
      const newPosition = Math.max(
        0,
        Math.min(this.thumbPosition + delta, this.trackWidth - 50),
      );

      this.thumbPosition = newPosition;

      // Aplicar transform directamente al elemento
      const thumbEl = document.querySelector(
        `[ref*="thumb-${this.draggingPedidoId}"]`,
      );
      if (thumbEl) {
        thumbEl.style.transform = `translateX(${newPosition}px)`;
      }
    },

    stopDrag() {
      if (!this.dragging) return;

      this.dragging = false;

      //quitar listeners
      window.removeEventListener("mousemove", this.onDrag);
      window.removeEventListener("mouseup", this.stopDrag);
      window.removeEventListener("touchmove", this.onDrag);
      window.removeEventListener("touchend", this.stopDrag);

      // Reset drag state
      this.lastDragTime = 0;

      // Limpiar clases de dragging y resetear transforms
      if (this.$refs.track) {
        this.$refs.track.classList.remove("dragging");
      }
      if (this.$refs.thumb) {
        this.$refs.thumb.classList.remove("dragging");
        this.$refs.thumb.style.transform = "";
      }

      if (this.thumbPosition >= this.trackWidth - 60) {
        this.confirmarAccion();
      } else {
        this.thumbPosition = 0;
      }
    },

    stopDrag2() {
      if (!this.dragging2) return;
      this.dragging2 = false;

      // quitar listeners
      window.removeEventListener("pointermove", this.onDrag2);
      window.removeEventListener("pointerup", this.stopDrag2);
      document.body.style.userSelect = "";

      // Reset drag state
      this.lastDragTime = 0;

      // Limpiar clases de dragging y resetear transforms
      const trackEl = document.querySelector(
        `[ref*="track-${this.draggingPedidoId}"]`,
      );
      const thumbEl = document.querySelector(
        `[ref*="thumb-${this.draggingPedidoId}"]`,
      );

      if (trackEl) {
        trackEl.classList.remove("dragging");
      }
      if (thumbEl) {
        thumbEl.classList.remove("dragging");
        thumbEl.style.transform = "";
      }

      if (this.thumbPosition >= this.trackWidth - 60) {
        this.confirmarAccion();
      } else {
        this.thumbPosition = 0;
      }

      this.draggingPedidoId = null;
    },

    getSiguienteEstado(pedido) {
      if (!pedido || !pedido.estado) return undefined;
      // Busca el estado por value, no por text
      const estadoEncontrado = this.ordenEstados.find(
        (estado) => estado.value === pedido.estado,
      );
      if (estadoEncontrado !== undefined) {
        const indice = this.ordenEstados.indexOf(estadoEncontrado);
        return this.ordenEstados[indice + 1];
      }
      return undefined;
    },

    getColorPorEstado(estado) {
      switch (estado) {
        case "pedido_creado":
          return "#C8E6C9";
        case "revision_de_credito":
          return "#FFF9C4";
        case "confirmado":
          return "#DCEDC8";
        case "facturacion":
          return "#FFECB3";
        case "preparacion_en_almacen":
          return "#FFE0B2";
        case "preparado":
          return "#FFCCBC";
        case "en_ruta_de_entrega":
          return "#FFCCBC";
      }
    },

    confirmarAccion() {
      const siguienteEstado = this.getSiguienteEstado(
        this.draggingPedidoId
          ? this.pedidos.find((p) => p.id === this.draggingPedidoId)
          : this.pedidoSeleccionado,
      );
      try {
        axios.post(
          `/pedidos/avanzar_pedido?id_pedido=${
            this.draggingPedidoId
              ? this.draggingPedidoId
              : this.pedidoSeleccionado.id
          }&nuevo_estado=${siguienteEstado.value}`,
        );
        alert(
          `Pedido #${
            this.draggingPedidoId
              ? this.draggingPedidoId
              : this.pedidoSeleccionado.id
          } avanzado a: ${siguienteEstado.text}`,
        );

        this.getPedidos();
      } catch (error) {
        console.error(error);
        alert("Error al avanzar el pedido.");
        this.thumbPosition = 0;
        return;
      }
      this.thumbPosition = 0;
    },
    checkOrientation() {
      this.isPortrait = window.innerHeight > window.innerWidth;
    },

    scrollToEstado(estadoValue) {
      this.$nextTick(() => {
        const estadoIndex = this.estados.findIndex(
          (e) => e.value === estadoValue,
        );
        if (estadoIndex !== -1) {
          const estadoElements = this.$el.querySelectorAll("h2");
          if (estadoElements[estadoIndex]) {
            estadoElements[estadoIndex].scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
          }
        }
      });
    },
    cantidadPedidosPorEstado(estado) {
      return this.pedidosPorEstado[estado]
        ? this.pedidosPorEstado[estado].length
        : 0;
    },

    marcarLeido(comentario) {
      comentario.leido = true;
      let leidos = JSON.parse(localStorage.getItem("comentariosLeidos")) || [];
      if (!leidos.includes(comentario.id)) {
        leidos.push(comentario.id);
        localStorage.setItem("comentariosLeidos", JSON.stringify(leidos));
      }
    },
  },
  computed: {
    ...mapGetters(["user"]),
    ...mapGetters(["currentUser"]),

    pedidosPorEstado() {
      const agrupados = {};
      for (const estado of this.estados) {
        agrupados[estado.value] = this.pedidos.filter(
          (p) => p.estado === estado.value,
        );
      }
      return agrupados;
    },

    comentariosPedidosOrdenados() {
      let comentarios = this.comentariosPedidos.slice();
      if (this.comentarioNotificado) {
        // Filtra para evitar duplicados
        comentarios = comentarios.filter(
          (c) => c.id !== this.comentarioNotificado.id,
        );
        comentarios = [this.comentarioNotificado, ...comentarios];
      }
      // Si no hay notificado, muestra todos normalmente
      return comentarios.sort((a, b) => {
        return new Date(b.fecha_creacion) - new Date(a.fecha_creacion);
      });
    },

    hayComentariosNoLeidos() {
      return this.comentariosPedidos.some((c) => !c.leido);
    },
  },
  created() {
    this.getUsuarios();
    this.getClientes();
    this.getProductos();
    this.getPermisoAgregarPrepedido();
    this.comentariosInterval = setInterval(() => {
      this.getComentariosNuevos();
    }, 5000); // cada 6 segundos*/
  },

  mounted() {
    this.getPedidos();
    this.getClientes();
    this.$nextTick(() => {
      if (this.$refs.track) {
        this.trackWidth = this.$refs.track.offsetWidth;
      }
    });
    // Añadir solo listeners globales necesarios
    window.addEventListener("resize", this.checkOrientation);
  },

  beforeDestroy() {
    // Remover solo listeners globales que añadimos en mounted
    window.removeEventListener("resize", this.checkOrientation);

    // Asegurar cancelar cualquier rAF pendiente
    if (this.dragRaf) cancelAnimationFrame(this.dragRaf);
    if (this.dragRaf2) cancelAnimationFrame(this.dragRaf2);

    // Intentar remover listeners de arrastre por seguridad
    try {
      window.removeEventListener("mousemove", this.onDrag);
      window.removeEventListener("mouseup", this.stopDrag);
      window.removeEventListener("touchmove", this.onDrag);
      window.removeEventListener("touchend", this.stopDrag);

      window.removeEventListener("pointermove", this.onDrag2);
      window.removeEventListener("pointerup", this.stopDrag2);
    } catch (e) {
      // ignore
    }

    clearInterval(this.comentariosInterval);
  },
  components: {
    AreaTrabajo,
    PreciosExistenciasView,
    verPedidoVendedor,
    FaltantesVendedores,
  },
};
</script>

<style scoped>
.bordered-button {
  border: 1px solid #ccc;
}

.swipe-track {
  position: relative;
  height: 50px;
  background: #ddd;
  border-radius: 25px;
  overflow: hidden;
  display: flex;
  align-items: center;
  /* Optimizaciones agresivas para tablets */
  touch-action: pan-y;
  will-change: transform;
  transform: translateZ(0); /* Forzar aceleración de hardware */
  contain: layout style paint; /* Aislamiento de renderizado */
  isolation: isolate; /* Crear nueva capa de apilamiento */
}

.swipe-fill {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  background: linear-gradient(
    to right,
    #6a8fb3,
    #1976d2 30%,
    #1976d2 70%,
    #6a8fb3 100%
  );
  transition: width 120ms linear;
  border-radius: 25px 0 0 25px;
  z-index: 1;
}

.swipe-thumb {
  position: absolute;
  top: 2px;
  left: 0;
  width: 50px;
  height: 46px;
  border-radius: 23px;
  background: #1976d2;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: grab;
  z-index: 2;
  /* Optimizaciones agresivas para tablets */
  touch-action: pan-y;
  will-change: transform;
  transform: translateZ(0); /* Forzar aceleración de hardware */
  contain: layout style paint; /* Aislamiento de renderizado */
  backface-visibility: hidden; /* Optimización adicional */
}

.swipe-thumb.dragging {
  transition: none !important;
  transform: none !important; /* Desactivar transform CSS, usamos JS directo */
}

.swipe-track.dragging * {
  transition: none !important; /* Desactivar todas las transiciones durante drag */
}

.swipe-text {
  width: 100%;
  text-align: center;
  position: absolute;
  font-weight: bold;
  color: #555;
  z-index: 0;
  pointer-events: none;
}

.enabled-button {
  background-color: #6a8fb3 !important;
  color: white !important;
}

.disabled-button {
  background-color: white !important;
  color: black !important;
}
.dialog-comentarios {
  background: rgba(255, 255, 255, 0.6) !important;
  backdrop-filter: blur(10px);
  border-radius: 15px; /* Bordes redondeados */
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.background-circle {
  background-color: #e0e0e0;
  border-radius: 20px;
  padding: 5px 15px;
  display: inline-block;
  max-width: 80%;
}
.comentario-no-leido {
  background: #e3f2fd;
  border-left: 4px solid #1976d2;
  border-radius: 8px;
  padding: 8px;
}

.v-card {
  scroll-margin-top: 80px;
}

.btn-historial {
  background-color: rgba(106, 143, 179, 0.8) !important;
}

.chip-estado {
  background-color: rgba(200, 230, 201, 0.8) !important;
}
</style>
